export default __webpack_public_path__ + "static/media/image-chairsensor-w@3x.eaa995dc.webp";